<template>
  <v-container>
    <p class="text-h6 text-md-h4 text-center pt-4 mb-0">Подбор курсов</p>
    <v-row justify="center" align="center">
      <v-col md="10" sm="12" class="text-center">
        <v-card class="mx-auto">
          <v-card-title class="title font-weight-regular justify-space-between">
            <span>{{ currentTitle }}</span>
          </v-card-title>

          <v-window v-model="step">
            <v-window-item :value="1">
              <v-container>
                <v-row justify="center" align="center">
                  <v-col md="6" sm="10">
                    <v-slider
                      v-model="age"
                      color="primary"
                      label="Возраст"
                      min="9"
                      max="60"
                      thumb-label
                    ></v-slider>
                    <p class="subtitle-1">{{ age + " лет" }}</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-window-item>

            <v-window-item :value="2">
              <v-item-group mandatory>
                <v-container>
                  <v-row>
                    <v-col md="6" v-on:click="category = 'grathics'">
                      <v-item v-slot="{ active, toggle }">
                        <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center"
                          dark
                          min-width="150"
                          height="200"
                          @click="toggle"
                        >
                          <v-scroll-y-transition>
                            <div
                              v-if="active"
                              class="title flex-grow-1 text-center"
                            >
                              Дизайн и графика
                            </div>
                            <div v-if="!active" class="flex-grow-1 text-center">
                              Графика и дизайн
                            </div>
                          </v-scroll-y-transition>
                        </v-card>
                      </v-item>
                    </v-col>
                    <v-col md="6" v-on:click="category = 'code'">
                      <v-item v-slot="{ active, toggle }">
                        <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center"
                          dark
                          height="200"
                          @click="toggle"
                        >
                          <v-scroll-y-transition>
                            <div
                              v-if="active"
                              class="title flex-grow-1 text-center"
                            >
                              Написание кода
                            </div>
                            <div v-if="!active" class="flex-grow-1 text-center">
                              Программирование
                            </div>
                          </v-scroll-y-transition>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-item-group>
            </v-window-item>

            <v-window-item :value="3">
              <div class="d-flex justify-space-around flex-wrap">
                <CoursePreview
                  v-for="(course, index) in myCourses"
                  :key="index"
                  :course="course"
                  :index="index"
                >
                </CoursePreview>
              </div>
            </v-window-item>
          </v-window>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn v-if="step != 1" text @click="step--"> Назад </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="step != 3"
              color="primary"
              depressed
              @click="coursesSelect"
            >
              Далее
            </v-btn>       
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import CoursePreview from "../components/CoursePreview";
import courses from "../../src/courses/courses";
export default {
  name: "StartPage",
  components: { CoursePreview },
  data: () => ({
    age: 9,
    min: 9,
    max: 60,
    step: 1,
    category: "grathics",
    courses: courses,
    myCourses: [],
  }),
  methods: {
    coursesSelect: function () {
      this.step++;
      this.myCourses = [];
      if (this.step == 3) {
        for (const key in this.courses) {
          if (
            this.courses[key].minAge <= this.age &&
            this.courses[key].maxAge >= this.age &&
            this.courses[key].category.indexOf(this.category) != -1
          ) {
            this.myCourses.push(this.courses[key]);
          }
        }
      }
    },
    toggleShow: function () {
      this.show = !this.show;
    },
  },

  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Сколько вам лет?";
        case 2:
          return "Что интереснее?";
        default:
          return "Вам подходят";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style> 


